import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProductCard, ProductCardSkeleton } from "@/components/ProductCard";
import RichText from "@/components/RichText";

// Chaque bloc "product_item" (theme_service.BLOCK_TYPES["recommended_products"])
// référence un produit par son id — sélection manuelle, à l'inverse d'une
// "Collection en vedette" qui liste automatiquement toute une catégorie.
// Un seul appel /products?ids=... regroupant tous les blocs.
export default function RecommendedProductsSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.enabled !== false && b.type === "product_item" && b.props?.product_id);
  const ids = items.map((b) => b.props.product_id);
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (!ids.length) { setProducts([]); return; }
    let cancelled = false;
    api.get("/products", { params: { ids: ids.join(",") } }).then(({ data }) => {
      if (cancelled) return;
      // Respecte l'ordre choisi dans l'éditeur (les blocs), pas l'ordre
      // renvoyé par la requête base.
      const byId = Object.fromEntries((data || []).map((p) => [p.id, p]));
      setProducts(ids.map((id) => byId[id]).filter(Boolean));
    }).catch(() => { if (!cancelled) setProducts([]); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join(",")]);

  if (!items.length) return null;

  return (
    <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-section md:py-section-md">
      {props.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-8"
          html={props.heading}
        />
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
        {products === null
          ? items.map((b) => <ProductCardSkeleton key={b.id} />)
          : products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
      </div>
    </section>
  );
}
